import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'moment-timezone';
import 'moment/min/locales.min';
import { environment } from './environments/environment';
import { hmrBootstrap } from './hmr';
import './polyfills.ts';
import { RootModule } from './root.module';
import { app, authentication } from '@microsoft/teams-js';
import { registerLicense } from '@syncfusion/ej2-base';

// Registering Syncfusion license key
registerLicense('Ngo9BigBOggjHTQxAR8/V1NNaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXpceXRQQ2FYUUFxWkVWYEo=');

if (environment.production) {
    enableProdMode();
}

const bootstrap = () => {
    return platformBrowserDynamic().bootstrapModule(RootModule);
};

// Capture OAuth callback URL immediately before Angular routing or ABP can change it.
// Both ActivatedRoute.snapshot.queryParams and window.location.search can be empty
// by the time ConsentPopupEndComponent.ngOnInit() runs (Angular router resets the URL,
// ABP APP_INITIALIZER may navigate, etc.). Storing it here in sessionStorage guarantees
// the raw URL is always available regardless of when the component initialises.
if (window.location.pathname.indexOf('/welcome/consent-end') >= 0 && window.location.search) {
    sessionStorage.setItem('vf_consent_callback_url', window.location.href);

    // If we are inside a hidden iframe (silent consent check), notify the parent
    // immediately — before Angular bootstraps. Angular bootstrap can take several
    // seconds; the silent-check timeout in _openConsentPopup is only 5 s, so
    // waiting for ConsentPopupEndComponent.ngOnInit() would be too late.
    var _isIframe = window !== window.parent && !window.opener;
    if (_isIframe) {
        var _params = new URLSearchParams(window.location.search);
        var _code = _params.get('code');
        var _state = _params.get('state');
        var _error = _params.get('error');
        var _errorDesc = _params.get('error_description');
        var _msg = _error
            ? { type: 'vf_consent_error', error: _errorDesc || _error }
            : (_code ? { type: 'vf_consent_success', code: _code, state: _state } : null);
        if (_msg) {
            window.parent.postMessage(_msg, window.location.origin);
        }
    }
}

// Teams admin-consent callback: call notifySuccess/notifyFailure immediately
// before Angular bootstraps. The Teams authenticate() popup has a short timeout;
// if we wait for Angular + ABP to fully initialise, the popup closes and Teams
// resolves with "CancelledByUser".
if (window.location.pathname.indexOf('/account/admin-consent-callback') >= 0) {
    (function () {
        var _p = new URLSearchParams(window.location.search);
        var _consent = _p.get('admin_consent');
        var _err = _p.get('error');
        var _errDesc = _p.get('error_description');
        try {
            app.initialize().then(function () {
                if (_err) {
                    authentication.notifyFailure(_errDesc || _err);
                } else if (_consent === 'True') {
                    authentication.notifySuccess('admin_consent_granted');
                } else {
                    authentication.notifyFailure('Unexpected response from Microsoft.');
                }
            }).catch(function () { /* Not in Teams context */ });
        } catch (e) { /* Not in Teams context */ }
    })();
}

/* "Hot Module Replacement" is enabled as described on
 * https://medium.com/@beeman/tutorial-enable-hrm-in-angular-cli-apps-1b0d13b80130#.sa87zkloh
 */
let isIframe = window !== window.parent && !window.opener;
if (isIframe) {
    if (!app.isInitialized()) {
        app.initialize();
    }
}
if (environment.hmr) {
    if (module['hot']) {
        hmrBootstrap(module, bootstrap); //HMR enabled bootstrap
    } else {
        // console.error('HMR is not enabled for webpack-dev-server!');
        // console.log('Are you using the --hmr flag for ng serve?');
    }
} else {
    bootstrap(); //Regular bootstrap
}
